import Button from "./Button";

/** The three ways to take content in. Matches the ConsumptionType rows the API filters on. */
export const CONSUMPTION_OPTIONS = ["Listen", "Read", "Watch"];

interface ConsumptionFiltersProps {
  /** The consumption currently in the URL, or `null` for All. */
  selected: string | null;
  /** Called with the chosen consumption, or `null` when All is chosen. */
  onSelect: (consumption: string | null) => void;
}

/**
 * The "Refine search" pills: All / Listen / Read / Watch.
 *
 * One component for /search and the topic page. They used to hold a copy each, and the
 * copies drifted -- the topic page's also pinned a `type` param, which narrowed the
 * search to one content table and emptied Listen and Watch. Two hand-maintained copies
 * of the same control is how that happened, so there is now only one.
 */
export default function ConsumptionFilters({ selected, onSelect }: ConsumptionFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2 justify-center items-center px-8 md:px-10 lg:px-12">
      {[null, ...CONSUMPTION_OPTIONS].map((option) => {
        const active = selected === option;
        return (
          <Button
            key={`refine-consumption-${(option ?? "all").toLowerCase()}`}
            onClick={() => onSelect(option)}
            width="fit"
            bgColour={active ? `dark-grey` : `transparent hover:bg-dark-grey`}
            borderColour="dark-grey"
            textColour={active ? `white` : `dark-grey hover:text-white`}
          >
            {active && (
              <span className="h-4 p-2 rounded-full bg-white mr-2" />
            )}
            {option ?? "All"}
          </Button>
        );
      })}
    </div>
  );
}
